import * as React from "react";

import { cn } from "@/lib/utils";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  inline?: boolean;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, inline, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          inline && "focus:outline-none bg-transparent",
          !inline &&
            "flex h-10 w-full rounded-md border border-input bg-transparent px-3 py-1 shadow-sm transition-colors file:border-0 file:bg-transparent file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-azure disabled:cursor-not-allowed disabled:opacity-50",
          className,
          type === "checkbox" && "h-4 w-4 rounded-sm border-input",
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
